var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-section-panel"},[(_vm.$slots.title)?_c('p',{staticClass:"v-section-panel__title"},[_vm._t("title")],2):_vm._e(),(_vm.$slots.content)?_c('div',[_vm._t("content")],2):_vm._e(),(_vm.useBreak)?_c('div',[_c('p',{staticClass:"v-section-panel__break-line"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }